import React from 'react'
import { ClipLoader } from 'react-spinners'

const CustomButton = ({ loading, width, title }) => {
  return (
    <button className="btn flash-bg p-2 px-4 fw-bold text-uppercase" style={{ width: width }}>
        { loading ? <ClipLoader size={20} /> : title }
    </button>
  )
}

export default CustomButton